import { stringify } from 'querystring';
import { fetchJSON } from '@catalogo/core-http';
import { removeUndef } from '@catalogo/core-helpers/utils';
import { readCookies } from '@catalogo/core-connect/cookies';

const getCategoryId = (context, categoryId) => {
  if (context !== 'product' && context !== 'category') {
    return 'virtual-home';
  }

  return categoryId;
};

const buildUrl = (
  url,
  device,
  placements = [],
  productId,
  categoryId,
  sessionId,
  userId,
  rid,
  term,
  context,
  enableAds
) => {
  const params = removeUndef({
    limit: 12,
    includeMVTData: true,
    includeStrategyData: true,
    returnMinimalRecItemData: true,
    sessionId,
    userId,
    placements: placements.join('|'),
    userAttribute: `device:${device}`,
    rid,
    searchTerm: context === 'search' ? term : undefined,
    categoryId: getCategoryId(context, categoryId),
    productId,
    enableAds,
  });

  return `${url}?${stringify(params)}`;
};

export default (config, cache, device) => async (_, args) => {
  const { cookies } = readCookies(cache);
  const { 'B2W-UID': userId, 'B2W-SID': sessionId, b2wRegion: rid } = cookies;
  if (!args.placements || args.placements.length < 1) {
    return {};
  }

  const response = await fetchJSON(
    buildUrl(
      config.endpoints.mars,
      device,
      args.placements,
      args.productId,
      args.categoryId,
      sessionId,
      userId,
      rid,
      args.term,
      args.pageType,
      args.enableAds
    )
  );

  if (!response.placements) {
    return {};
  }

  const components = response.placements.reduce(
    (prev, { placement, strategyMessage, strategyName, recommendedProducts }) => {
      if (recommendedProducts.length < 1) {
        return prev;
      }

      prev[placement] = {
        type: 'carousel',
        title: strategyMessage,
        products: recommendedProducts.map(({ id, clickTrackingURL: trackingUrl, ads }, index) => {
          if (ads) {
            const { id, url, queryString, seller_id: sellerId, chave } = ads;
            return {
              id,
              key: chave,
              trackingUrl: url,
              queryString: `DCSext.recom=RR_${placement}-${strategyName}&nm_origem=rec_${placement}-${strategyName}&nm_ranking_rec=${
                index + 1
              }&${queryString}`,
              sellerId,
              isAd: true,
            };
          }
          return {
            id,
            trackingUrl,
            queryString: `DCSext.recom=RR_${placement}-${strategyName}&nm_origem=rec_${placement}-${strategyName}&nm_ranking_rec=${
              index + 1
            }`,
          };
        }),
        rule: strategyName,
      };

      return prev;
    },
    {}
  );
  return { components, mvt: response.mvt };
};
